import { useCallback, useEffect } from "react";
import { useAppContext, useService } from "../../../../hooks";

export const useRecentServices = () => {
  const {
    actions: { setServices },
    selectors: { getServices },
  } = useAppContext();
  const { getServices: fetchServices } = useService("Service");

  const getServicesData = useCallback(async () => {
    const result = await fetchServices();
    if (result.status) {
      if (result.data?.length !== 0) {
        setServices(result.data);
      }
    }
  }, [setServices]);
  const compare = (a, b, key = "publishDate") => {
    if (new Date(a[key]) < new Date(b[key])) return -1;
    if (new Date(a[key]) > new Date(b[key])) return 1;
    return 0;
  };

  useEffect(() => {
    getServicesData();
  }, []);
  return {
    serviceList: getServices().sort(compare).slice(0, 3),
  };
};
